// Explore-stats page: Speakers of the House of Representatives.
// Recreates the Handbook page — every Speaker since Federation, party &
// cumulative length of service, longest tenures, and a sortable
// name/party/period/duration table with PHID-linked names (#200).
// Thin wrapper around the shared OfficeHolderTenure scaffold.

import React from 'react';
import OfficeHolderTenure from './OfficeHolderTenure';

export default function Speakers() {
  return (
    <OfficeHolderTenure
      slug="speakers"
      title="Speakers of the House of Representatives"
      description={
        'Speakers of the House of Representatives since Federation '
        + '— ranked by cumulative tenure'
      }
    />
  );
}
